import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const programasRoutes: Routes = [
  {
    path: 'programas',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Gerenciar Programas',
      breadcrumb: [{ label: 'Gerenciar Programas' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./programas.component').then((m) => m.ProgramasComponent),
        data: {
          title: 'Gerenciar Programas',
          roles: [Role.PROGRAMA_CONSULTAR],
          breadcrumb: [{ label: 'Programas', url: '/programas' }],
        },
      },
      {
        path: 'cadastrar',
        data: {
          title: 'Cadastrar Programa',
          roles: [Role.PROGRAMA_CADASTRAR],
          breadcrumb: [
            { label: 'Programas', url: '/programas' },
            { label: 'Cadastrar', url: '/programas/cadastrar' },
          ],
        },
        loadComponent: () =>
          import('./programa-form/programa-form.component').then(
            (m) => m.ProgramaFormComponent,
          ),
      },
      {
        path: 'editar/:id',
        data: {
          title: 'Editar Programa',
          roles: [Role.PROGRAMA_EDITAR],
          breadcrumb: [
            { label: 'Programas', url: '/programas' },
            { label: 'Editar', url: '/programas/editar' },
          ],
        },
        loadComponent: () =>
          import('./programa-form/programa-form.component').then(
            (m) => m.ProgramaFormComponent,
          ),
      },
    ],
  },
];
